import React, { useMemo, useCallback } from 'react';
import propTypes from 'prop-types';
import { UiTable } from 'src/ui';
import { Button, MuiDropdown, MuiDropdownItem } from 'src/ui/mui-ui-kit';;
;
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NavLink, Link } from 'react-router-dom';
import Moment from 'moment';

export function LoansTable({ loading, loans, onDeleteLoan }) {
  const onDelete = useCallback(loan => {
    return () => onDeleteLoan(loan);
  }, []);
  const tableColumns = useMemo(
    () => [
      {
        Header: 'Loan ID',
        accessor: 'loanIdentifier',
        Cell: row => (
          <Link className="edit-link" to={`/loans/edit/${row.original.id}`}>
            {row.value ? row.value : row.original.id}
          </Link>
        ),
      },
      {
        Header: 'Loan Amount',
        accessor: 'loanAmount',
        Cell: row => (
          <Link className="edit-link" to={`/loans/edit/${row.original.id}`}>
            {row.value}
          </Link>
        ),
      },
      {
        Header: 'Payment Amount',
        accessor: 'loanPaymentAmount',
        Cell: row => (
          <Link className="edit-link" to={`/loans/edit/${row.original.id}`}>
            {row.value}
          </Link>
        ),
      },
      {
        Header: 'Payment Method',
        accessor: 'loanPaymentMethod',
        Cell: row => (
          <Link className="edit-link" to={`/loans/edit/${row.original.id}`}>
            {row.value}
          </Link>
        ),
      },
      {
        Header: 'Date Added',
        accessor: 'loanAddedDate',
        Cell: row => (
          <Link className="edit-link" to={`/loans/edit/${row.original.id}`}>
            {Moment(row.value).format('YYYY/MM/DD')}
          </Link>
        ),
      },
      {
        Header: 'Date Closed',
        accessor: 'loanClosedDate',
        Cell: row => (
          <Link className="edit-link" to={`/loans/edit/${row.original.id}`}>
            {Moment(row.value).isValid() &&
              Moment(row.value).format('YYYY/MM/DD')}
            {!Moment(row.value).isValid() && 'Pending'}
          </Link>
        ),
      },
      {
        Header: '',
        accessor: 'id',
        sortable: false,
        width: 62,
        resizable: false,
        Cell: row => (
          <MuiDropdown
            renderTrigger={
              <Button isColor="white">
                <span className="icon">
                  <FontAwesomeIcon
                    icon={['fal', 'ellipsis-v']}
                    className="has-text-grey"
                    size="lg"
                  />
                </span>
              </Button>
            }
          >
              <MuiDropdownItem tag={NavLink} to={`/loans/edit/${row.value}`}>
                Edit
              </MuiDropdownItem>
              <MuiDropdownItem tag="a" onClick={onDelete(row.original)}>
                Archive
              </MuiDropdownItem>
          </MuiDropdown>
        ),
      },
    ],
    []
  );

  return (
    <UiTable
      columns={tableColumns}
      loading={loading}
      data={loans}
      title="Loan"
      emptyTo="/loans/add"
      resolveData={data =>
        data.map(loan => ({
          ...loan,
          fullAddress: `${loan.address} ${loan.address2 || ''}`,
        }))
      }
      getTheadThProps={(_state, _rowInfo, column) => ({
        className: [
          'id',
          'loanAmount',
          'paymentMethod',
          'loanAddedDate',
          'loanClosedDate',
          'loanPaymentAmount',
        ].includes(column.id)
          ? 'has-text-left'
          : '',
      })}
      toNext="/people"
      toPrev="/business"
      hideNext
      hidePrev
    />
  );
}

LoansTable.propTypes = {
  loading: propTypes.bool.isRequired,
  loans: propTypes.arrayOf(propTypes.object).isRequired,
  onDeleteLoan: propTypes.func.isRequired,
};
